import AnimatedSection from '../../../components/base/AnimatedSection';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center">
      <img
        src="https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/1a122c4da9134047337b60b42740f830.png"
        alt="Hero Background"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Artist image — bottom right corner */}
      <div className="absolute bottom-0 right-0 w-[380px] h-[65vh] hidden md:block z-10">
        <img
          src="https://public.readdy.ai/ai/img_res/36a4c146-3d5d-46fc-a52e-90f50ffde08d.png"
          alt="Artist"
          className="w-full h-full object-contain object-bottom"
        />
      </div>

      {/* Logo top-left + Premium Sound tagline */}
      <div className="absolute top-[6%] left-[4%] z-20 flex flex-col items-center">
        <img
          src="https://public.readdy.ai/ai/img_res/a00dfc0e-e63a-4686-b358-4848806e6b67.png"
          alt="NCMG Productions Logo"
          className="h-12 md:h-20 w-auto object-contain"
        />
        <p style={{
          fontFamily: "'Georgia', 'Times New Roman', serif",
          fontSize: '0.6rem',
          letterSpacing: '0.3em',
          color: 'rgba(255,255,255,0.92)',
          textTransform: 'uppercase',
          marginTop: '3px',
          textAlign: 'center',
          textShadow: '0 0 12px rgba(255,255,255,0.5)',
        }}>
          Premium Sound
        </p>
      </div>

      {/* Centered hero content */}
      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <AnimatedSection animation="fade-up" delay={100}>
          <img
            src="https://static.readdy.ai/image/0542b55361f16146c294ce449fc8d2da/9dbcee623adb676910d3f4f33f182962.png"
            alt="Premium Beats"
            className="hero-beat-image"
          />
        </AnimatedSection>

        <AnimatedSection animation="fade-up" delay={300}>
          <p className="text-xs md:text-lg text-white/90 mt-5 md:mt-10 mb-5 md:mb-8 font-light leading-relaxed max-w-xs md:max-w-2xl px-2 md:px-0">
            Exclusive production-ready beats built for artists who demand professional-grade quality. Reggaeton · Dembow · Pop · Hip-Hop · Afro Beats &amp; More
          </p>
        </AnimatedSection>

        <AnimatedSection animation="fade-up" delay={500}>
          <div className="flex gap-3 md:gap-4 justify-center">
            <a
              href="#beats"
              className="px-5 py-2.5 md:px-8 md:py-4 bg-red-600 text-white rounded-full font-semibold text-sm md:text-base hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
            >
              Browse Beats
            </a>
            <a
              href="#booking"
              className="px-5 py-2.5 md:px-8 md:py-4 border-2 border-white text-white rounded-full font-semibold text-sm md:text-base hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
            >
              Book Session
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}